import { IonPage } from '@ionic/react'

import { PortalUnitsView } from '@apps-common/apps/portal/pages/units/components/portal/PortalUnitsView'
import { AUTH_CLAIMS, Authorization } from '@apps-common/lib'

import { ManagementUnitsView } from './components/management/ManagementsUnitView'

export const UnitsPage = () => (
  <IonPage>
    <Authorization
      roles={AUTH_CLAIMS.managementAdmin.roles}
      scopes={AUTH_CLAIMS.managementAdmin.scopes}
      notAuthorizedFallback={<PortalUnitsView />}
    >
      <ManagementUnitsView />
    </Authorization>
  </IonPage>
)
